import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "@mui/lab/LoadingButton";
import { LLMConfigurationDataType } from "../../types";
import { deleteLLMConfiguration } from "../../apis/llm-configurations";
interface Props {
    open: boolean;
    handleCloseDeleteModal: () => void;
    currentLLMConfiguration?: LLMConfigurationDataType;
    setLLMConfigurationList: React.Dispatch<React.SetStateAction<(LLMConfigurationDataType)[]>>
}

export default function DeleteTopic({
    open,
    handleCloseDeleteModal,
    currentLLMConfiguration,
    setLLMConfigurationList
}: Props) {
    const [loader, setLoader] = useState(false);
    const handleDelete = async () => {
        if (currentLLMConfiguration?.id) {
            setLoader(true);
            const response = await deleteLLMConfiguration(`${currentLLMConfiguration?.id}`);
            if (response)
                setLLMConfigurationList(prev => prev?.filter(value => `${value?.id}` !== `${currentLLMConfiguration?.id}`));
            setLoader(false);
            handleCloseDeleteModal();
        }
    };

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleCloseDeleteModal}
                aria-labelledby="draggable-dialog-title"
            >
                <DialogTitle
                    sx={{ mb: 0 }}
                    style={{ cursor: "move" }}
                    id="draggable-dialog-title"
                >
                    Delete LLM Configuration
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this LLM Configuration?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCloseDeleteModal}>
                        Cancel
                    </Button>
                    <LoadingButton
                        loading={loader}
                        color={"error"}
                        variant="contained"
                        onClick={handleDelete}
                    >
                        Delete
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
}
